import { TemplateHistoryApiResultObject } from "./TemplateHistoryApiResult";
import { ContractNameNumber, 
         CustomerNameId, 
         ItemNameNumber, 
         ProductLineCategoryNameNumber, 
         ProductLineNameNumber } from "./TemplateMetadataModels";

export type SpecialPricingExpirationTemplateHistoryApiResultObject = 
    TemplateHistoryApiResultObject & 
    SpecialPricingExpirationTemplateHistoryMetadata;

export type SpecialPricingExpirationTemplateHistoryMetadata = {
    Customers: CustomerNameId[] | null,
    Items: ItemNameNumber[] | null,





    Contracts: ContractNameNumber[] | null,
    ProductLines: ProductLineNameNumber[] | null,
    ProductLineCategories: ProductLineCategoryNameNumber[] | null,
    HasNewTerms: boolean | null
}

export const SpecialPricingExpirationTemplateHeaderRows_AoA = [
    [
        "AGREEMENT NUMBER",
        "CONTROL NUMBER",
        "CUSTOMER NAME",
        "CUSTOMER ADDRESS",
        "PRODUCT LINE",
        "PRODUCT CATEGORY",
        "MANUFACTURERS NUMBER",
        "EXTEND/DELETE/CANCEL/NEW",
        "CONTACT EMAIL",
        "COMMENTS",
        "CONTRACT NUMBER",
        "CONTRACT NAME",
        "CUSTOMER NUMBER",
        "ITEM",
        "ITEM DESCRIPTION",
        "PRODUCT LINE DESCRIPTION",
        "PRODUCT CATEGORY DESCRIPTION",
        "EMPLOYEE RESPONSIBLE NAME",
        "PRICE TYPE",
        "PRICE",
        "PRICING UOM",
        "DELIVERY EFFECTIVE DATE",
        "DELIVERY EXPIRATION DATE",
        "FLOAT PERCENT",
        "EXTEND DATE",
        "NEW PRICING AMOUNT",
        "NEW PRICE UOM",
        "NEW CONTRACT NUMBER",
        "NEW CONTRACT NAME",
        "NEW START DATE",
        "NEW END DATE",
        
        //"JOB TYPE",
        //"SUPPLIER RESPONSIBLE Y/N",
    ]
];
